<template>

  <div class="container">
    <p class="annotator-title">Action type (optional)</p>
    <div v-for="action in actions"
         :key="action.key"
         class="annotator-button"
         :class="selected === action.annotation ? 'selected' : ''"
         @click="select(action.key)">
      <p class="keyboard-shortcut">{{ action.key.toUpperCase() }}</p>
      <p class="annotator-button-txt">{{ action.name }}</p>
    </div>
    <!-- <div class="annotator-button" :class="selected === 'penalty' ? 'selected' : ''" @click="select('penalty')">
      <p class="keyboard-shortcut">K</p>
      <p class="annotator-button-txt">Penalty</p>
    </div>
    <div class="annotator-button" :class="selected === 'freekick' ? 'selected' : ''" @click="select('freekick')">
      <p class="keyboard-shortcut">L</p>
      <p class="annotator-button-txt">Free kick</p>
    </div>
    <div class="annotator-button" :class="selected === 'corner' ? 'selected' : ''" @click="select('corner')">
      <p class="keyboard-shortcut">M</p>
      <p class="annotator-button-txt">Corner</p>
    </div> -->
  </div>

</template>

<script>

import { getSportInfos } from '../helpers/get-sport-infos'

export default {
  name: 'CreamVideoAnnotator',
  props: ['sportID'],
  data () {
    return {
      selected: '',

      actionList: {
        football: [
          {
            key: 'o',
            name: 'Long shot',
            annotation: 'longshot'
          },
          {
            key: 'p',
            name: 'Volley',
            annotation: 'volley'
          },
          {
            key: 'k',
            name: 'Penalty',
            annotation: 'penalty'
          },
          {
            key: 'l',
            name: 'Free kick',
            annotation: 'freekick'
          },
          {
            key: 'm',
            name: 'Corner',
            annotation: 'corner'
          }
        ],
        basketball: [
          {
            key: 'p',
            name: 'Block',
            annotation: 'block'
          },
          {
            key: 'j',
            name: 'Dunk',
            annotation: 'dunk'
          },
          {
            key: 'k',
            name: 'Three points',
            annotation: 'threepoints'
          },
          {
            key: 'l',
            name: 'Alley oop',
            annotation: 'alleyoop'
          },
          {
            key: 'm',
            name: 'Free throw',
            annotation: 'freethrow'
          }
        ],
        handball: [
          {
            key: 'i',
            name: 'Spin shot\n(roucoulette)',
            annotation: 'spinshot'
          },
          {
            key: 'o',
            name: 'Save',
            annotation: 'save'
          },
          {
            key: 'p',
            name: 'Penalty',
            annotation: 'penalty'
          },
          {
            key: 'k',
            name: 'Kung-fu',
            annotation: 'kungfu'
          },
          {
            key: 'l',
            name: 'Lob',
            annotation: 'lob'
          },
          {
            key: 'm',
            name: 'Free throw',
            annotation: 'freethrow'
          }
        ]
      }
    }
  },
  methods: {
    select (key) {
      for (let action of this.actions) {
        if (action.key === key) {
          if (this.selected === action.annotation) {
            this.selected = ''
          } else {
            this.selected = action.annotation
          }
        }
      }
    },
    annotate (videoid) {
      if (this.selected) {
        this.$store.dispatch('patchVideo', {
          id: videoid,
          patch: {
            action: this.selected
          }
        })

        this.selected = ''
      }
    }
  },
  computed: {
    actions () {
      return this.actionList[getSportInfos({id: this.sportID}).urlName]
    }
  }
}

</script>

<style lang="scss" scoped>

  p {
    margin: 0;
  }

  .container {
    margin: 64px 0 0 0;
    padding: 12px;
    border: 1px solid #d0d0d0;
    background-color: white;
    width: fit-content;
    height: fit-content;
  }

  .annotator-title {
    font-weight: bold;
    margin-bottom: 12px;
  }

  .annotator-button {
    position: relative;
    cursor: pointer;
    width: 180px;
    margin-bottom: 6px;
    padding: 12px 0;
    border: 1px solid #d0d0d0;
    border-radius: 2px;
    display: grid;

    &:hover {
      background-color: #e8e8e8;
    }

    &.selected {
      background-color: rgba(blue, 0.12);
    }
  }

  .keyboard-shortcut {
    position: absolute;
    left: 18px;
    top: 50%;
    transform: translate(-50%, -50%);
    font-size: 20px;
    font-weight: bold;
    color: #d0d0d0;
  }

  .annotator-button-txt {
    justify-self: center;
    align-self: center;
    text-align: center;
    white-space: pre-line;
  }

</style>



// WEBPACK FOOTER //
// src/components/CreamVideoAnnotator.vue